/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{ "rawString": ".root_f28957f3{display:inline-block}\n" }]);
export var root = "root_f28957f3";
//# sourceMappingURL=GroupSpacer.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib-es2015/components/GroupedList/GroupSpacer.scss.js
// module id = 752
// module chunks = 0